// Ручной список тизеров «Материалы в подписке»
// Заполните реальными данными: title, icon_url (картинка), link (произвольная ссылка)
export interface SubscriptionTeaserCard {
  card_id: number
  title: string
  icon_url: string
  // Необязательное поле для переопределения ссылки перехода
  link?: string
}

import cake from '../assets/images/notSub/cake.png'
import cake1 from '../assets/images/notSub/cake-1.png'
import cake2 from '../assets/images/notSub/cake-2.png'
import cake3 from '../assets/images/notSub/cake-3.png'
import cake4 from '../assets/images/notSub/cake-4.png'
import cake5 from '../assets/images/notSub/cake-5.png'
import cake6 from '../assets/images/notSub/cake-6.png'
import cake7 from '../assets/images/notSub/cake-7.png'
import cake8 from '../assets/images/notSub/cake-8.png'
import cake9 from '../assets/images/notSub/cake-9.png'

export const SUBSCRIPTION_TEASERS: SubscriptionTeaserCard[] = [
  {
    card_id: 900001,
    title: 'Муссовые торты',
    icon_url: cake,
    link: '/subscribe',
  },
  {
    card_id: 900002,
    title: 'Капкейки и пирожные',
    icon_url: cake1,
    link: '/subscribe',
  },
  {
    card_id: 900003,
    title: 'Классические торты',
    icon_url: cake2,
    link: '/subscribe',
  },
  {
    card_id: 900004,
    title: 'Печенье и пряники',
    icon_url: cake3,
    link: '/subscribe',
  },
  {
    card_id: 900005,
    title: 'Бенто-торты',
    icon_url: cake4,
    link: '/subscribe',
  },
  {
    card_id: 900006,
    title: 'Кремы',
    icon_url: cake5,
    link: '/subscribe',
  },
  {
    card_id: 900007,
    title: 'Мороженое и десерты',
    icon_url: cake6,
    link: '/subscribe',
  },
  {
    card_id: 900008,
    title: 'Конфеты',
    icon_url: cake7,
    link: '/subscribe',
  },
  {
    card_id: 900009,
    title: 'Декоры Pauline Cake',
    icon_url: cake8,
    link: '/subscribe',
  },
  {
    card_id: 900010,
    title: 'Декоры для бенто-тортов',
    icon_url: cake9,
    link: '/subscribe',
  },
]


